import { Action, Reducer } from 'redux'
import { IShipperRate, IModalsState } from 'apps/rms/types/shipperRates'
import { EDIT_SHIPPER_RATE_MODAL } from 'apps/rms/utils/actions/shipperRates'

const { EDIT_SHIPPER_RATE_MODAL_CLOSE, EDIT_SHIPPER_RATE_MODAL_OPEN } = EDIT_SHIPPER_RATE_MODAL

interface IEditShipperRateAction extends Action<string> {
  payload?: {
    rate?: IShipperRate
  }
}

type ModalsAction = IEditShipperRateAction

const defaultState: IModalsState = {
  showEditModal: false,
}

const modalsReducer: Reducer<IModalsState, ModalsAction> = (state = defaultState, action) => {
  switch (action.type) {
    case EDIT_SHIPPER_RATE_MODAL_OPEN: {
      return {
        ...state,
        showEditModal: true,
        editModalPayload: (action as IEditShipperRateAction).payload,
      }
    }

    case EDIT_SHIPPER_RATE_MODAL_CLOSE: {
      return {
        ...state,
        showEditModal: false,
        editModalPayload: {},
      }
    }

    default:
      return state
  }
}

export default modalsReducer
